import { render, staticRenderFns } from "./UseCases.vue?vue&type=template&id=6dc2013c&scoped=true&"
import script from "./UseCases.vue?vue&type=script&lang=js&"
export * from "./UseCases.vue?vue&type=script&lang=js&"
import style0 from "./UseCases.vue?vue&type=style&index=0&id=6dc2013c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2013c",
  null
  
)

export default component.exports